import { CountrySource } from 'app/constants/configuration/countrySource'

export const getCountrySourceName = (
  countrySource: CountrySource,
  translate: (string) => string,
): string => {
  const text: string = CountrySource[countrySource]
  return translate(`countrySource.${text}`)
}
